export default {
  globalConfig: {},
  shop: {},
  newColorConfig: {},
  newFontsConfig: {},
  newOtherConfig: {},
  pluginData: {},
  activeWidgets: {
    productWidget: false,
    stars: false,
    footerBadges: false,
    carousel: false,
  },
};
